<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @print="print"
                    @execute="execute" @del="del" ref="SetBtn"></buttonlist>
        <!-- 功能按钮 -->
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="PurReceiveInHeadViewInfo"
                        :filter_language="['Order_Status','Finance_Status','Negative_Flag','invoice_flag']"
                        :filter_thousandth_puramount="['Total_Amount','line_tax_amount']"
                        :header="tableHeader"
                        :option="tableOption"
                        @handleCurrentChanges="handleCurrentChanges"
                        @edits="editInfo"
                        @rowdblclick="openEdit"
                        :row-class-name="tableRowClassName"
                        :checkflg="false"
                        ref="singleTable"
                ></wTable>
                <!--<el-table
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        @row-click="editInfo"
                        @row-dblclick="openEdit"
                        @current-change="handleCurrentChanges"
                        :height="tableHeight"
                        header-row-class-name="headerclass"
                        style="width: 100%;"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Order_No" :label="$t('getapi[3102]')">
                        <template scope="scope">
                            <input
                                    type="text"
                                    class="fsd clerinput"
                                    @keydown="keydown($event, scope.$index)"
                                    @keyup="keyup($event, scope.row)"
                                    v-model="scope.row.Order_No"
                                    readonly
                            />
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="PO_Code" :label="$t('getapi[1710]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Purchase_Person"
                                     :label="$t('getapi[1167]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="VenderCode"
                                     :label="$t('getapi[1196]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Payment_Mode"
                                     :label="$t('getapi[1099]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Finance_Date"
                                     :label="$t('getapi[1857]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_Person"
                                     :label="$t('getapi[1858]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_Date"
                                     :label="$t('getapi[1859]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Person"
                                     :label="$t('getapi[4043]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Date"
                                     :label="$t('getapi[742]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Negative_Flag"
                                     :label="$t('getapi[1860]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Order_Status"
                                     :label="$t('getapi[1861]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Finance_Status"
                                     :label="$t('getapi[1862]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Total_Amount" label="未税总金额"
                                     align="right" v-if="view_authority_showprice"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="line_tax_amount" label="含税总金额"
                                     align="right" v-if="view_authority_showprice"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Keep_Person"
                                     :label="$t('getapi[1864]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Regist_Person"
                                     :label="$t('getapi[4470]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="invoice_flag"
                                     :label="$t('getapi[1865]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="order_category"
                                     :label="$t('getapi[1866]')"></el-table-column>
                </el-table>-->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div class="btnnowrap">
                    <!--<el-button type="primary" size="mini" @click="audit" :disabled="!btn.Audit">{{ $t('getapi[3607]')
                        }}
                    </el-button>-->
                    <el-button type="primary" size="mini" @click="keepAccount" :disabled="!btn.Balance">{{
                        $t('getapi[3753]') }}
                    </el-button>
                    <el-button type="primary" size="mini" @click="recoveryAccount" :disabled="!btn.RBalance">{{
                        $t('getapi[1869]') }}
                    </el-button>
                    <el-button type="primary" size="mini" @click="showRemark" :disabled="!btn.remark" >{{showRemarkNmae}}</el-button>
                    <el-button type="primary" size="mini" @click="UpdateInvoiceQty" :disabled="!updateInvQty">{{
                        $t('getapi[12272]') }}
                    </el-button>
                    <el-button type="primary" size="mini" @click="collsoPrint" :disabled="dataDetail.InHead.order_no == ''">{{
                        $t('getapi[940]') }}
                    </el-button>
                </div>
                <div style="width:950px">
                    <table>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[463]') }}</td>
                            <td style="width:150px;">
                                <el-input v-model="dataDetail.InHead.order_no" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[1099]') }}</td>
                            <td style="width:150px;">
                                <el-input v-model="dataDetail.InHead.payment_mode" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[552]') }}</td>
                            <td style="width:100px;">
                                <el-input :value="expStatus(dataDetail.InHead.order_status)" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[1862]') }}</td>
                            <td style="width:100px;">
                                <el-input :value="expFinanceStatus(dataDetail.InHead.finance_status)" type="text"
                                          size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[4470]') }}</td>
                            <td style="width:150px;">
                                <routejump :urlNo="6" v-if="addoredit == 1">
                                <el-input
                                        v-model="dataDetail.InHead.regist_person"
                                        type="text"
                                        readonly
                                        class="mcolor"
                                        size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectemployee(1)"></i>
                                </el-input>
                                </routejump>
                                <el-input v-model="dataDetail.InHead.regist_person" type="text" size="mini"
                                          :readonly="true" class="readO" v-if="addoredit != 1"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[1167]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.InHead.purchase_person" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[1857]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.InHead.finance_date" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>{{ $t('getapi[1865]') }}</td>
                            <td>
                                <el-input :value="dataDetail.InHead.invoice_flag == 1 ? '是' : '否'" type="text"
                                          size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[1863]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.InHead.total_amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                          align="right" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[4472]') }}</td>
                            <td>
                                <!--<el-input v-model="dataDetail.InHead.keep_person" type="text" size="mini"></el-input>-->
                                <routejump :urlNo="6" v-if="addoredit == 1">
                                <el-input
                                        v-model="dataDetail.InHead.keep_person"
                                        type="text"
                                        readonly
                                        class="mcolor"
                                        size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectemployee(2)"></i>
                                </el-input>
                                </routejump>
                                <el-input v-model="dataDetail.InHead.keep_person" type="text" size="mini"
                                          :readonly="true" class="readO" v-if="addoredit != 1"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[1889]') }}</td>
                            <td>
                                <routejump :urlNo="29" v-if="addoredit == 1">
                                <el-input
                                        v-model="dataDetail.InHead.po_code"
                                        type="text"
                                        readonly
                                        class="mcolor"
                                        size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectOrder()"></i>
                                </el-input>
                                </routejump>
                                <el-input v-model="dataDetail.InHead.po_code" type="text" size="mini" :readonly="true" class="readO"
                                          v-if="addoredit != 1"></el-input>
                            </td>
                            <td>{{ $t('getapi[1196]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.InHead.versioncode" type="text" size="mini"
                                          style="width:100%" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[1197]') }}</td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.InHead.versionname" type="text" size="mini"
                                          style="width:100%" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[1866]') }}</td>
                            <td>
                                <el-select filterable v-model="dataDetail.InHead.order_category" size="mini"
                                           :disabled="addoredit == 2">
                                    <el-option v-for="item in UseArray" :key="item.Code" :label="item.Name"
                                               :value="item.Code"></el-option>
                                </el-select>
                            </td>
                        </tr>
                    </table>
                </div>
                <el-tabs :tab-position="'top'" type="" @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[1872]')" name="0" id="xdetilpane-0">
                        <div class="btnnowrap">
                            <el-button type="primary" size="mini" @click="importPart()" :disabled="!btn.ImportPart">
                                导入可入库材料
                            </el-button>
                            <el-button type="primary" size="mini" @click="showAddBom('')" :disabled="!btn.AddDetail">{{ $t('getapi[6092]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="batchDel" :disabled="!btn.rowdel">{{
                                $t('getapi[1522]') }}
                            </el-button>

                        </div>
                        <vxe-table
                                :data="dataDetail.NotAssistList"
                                @checkbox-change="handleSelectionChange"
                                :row-class-name="tableRowClassNameNot"
                                :highlight-current-row="true"
                                style="width: 100%; margin-top:3px"
                                :height="tableHeight - 220"
                                resizable
                                show-overflow="tooltip"
                                header-row-class-name="headerclass"
                                size="mini"
                                border
                                @sort-change="sortChange"
                                :default-sort="sortRule"
                                ref="singleTable1"
                        >
                            <vxe-table-column type="checkbox" align="center"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="line_no" :title="$t('getapi[1425]')" sortable
                                              align="right" width="50"></vxe-table-column>
                            <vxe-table-column field="relation_regist_order_no"
                                              :title="$t('getapi[1874]')" sortable width="150">
                                <template slot-scope="scope">
                                    <!--<el-input size="mini" v-model="scope.row.part_code"
                                              @dblclick.native="showItem(scope)"></el-input>-->
                                    <el-input
                                            v-model="scope.row.relation_regist_order_no"
                                            type="text"
                                            raedonly
                                            class="mcolor"
                                            size="mini"
                                            v-if="dataDetail.InHead.order_status == 0"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="showAddBom(scope)"></i>
                                    </el-input>
                                    <span v-if="dataDetail.InHead.order_status != 0">{{scope.row.relation_regist_order_no}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="relation_regist_order_line_no"
                                              :title="$t('getapi[1875]')" sortable align="right" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="delive_order_no"
                                              :title="$t('getapi[1744]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="category_firstname"
                                              :title="$t('getapi[169]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="category_secondname"
                                              :title="$t('getapi[170]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="category_thirdname"
                                              :title="$t('getapi[172]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_code"
                                              :title="$t('getapi[112]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_version"
                                              :title="$t('getapi[149]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_name"
                                              :title="$t('getapi[116]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="application_department"
                                              :title="$t('getapi[6041]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column field="cargoposition_code"
                                              :title="$t('getapi[1882]')" sortable width="120">
                                <template slot-scope="scope">
                                    <el-input
                                            v-model="scope.row.cargoposition_code"
                                            type="text"
                                            readonly
                                            class="mcolor"
                                            size="mini"
                                            v-if="dataDetail.InHead.order_status == 0"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="showPurCargo(scope)"></i>
                                    </el-input>
                                    <span v-if="dataDetail.InHead.order_status != 0">{{scope.row.cargoposition_code}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_finance_type"
                                              :title="$t('getapi[119]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_stuff"
                                              :title="$t('getapi[126]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_model"
                                              :title="$t('getapi[124]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_spec"
                                              :title="$t('getapi[125]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="freevalue"
                                              :title="$t('getapi[8958]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="pur_measure"
                                              :title="$t('getapi[1166]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="pur_measure_receivable_qty"
                                              :title="$t('getapi[1876]')" sortable align="right" width="100"></vxe-table-column>
                            <vxe-table-column field="pur_measure_actually_qty"
                                              :title="$t('getapi[1877]')" sortable align="right" width="100">
                                <template slot-scope="scope">
                                    <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                              v-model="scope.row.pur_measure_actually_qty" @change="getNotPurInvQty(scope,1)" v-if="dataDetail.InHead.order_status == 0"></el-input>
                                    <span v-if="dataDetail.InHead.order_status != 0">{{scope.row.pur_measure_actually_qty}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="exchange_rate" :title="$t('getapi[3599]')" sortable
                                              align="right" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="inv_measure"
                                              :title="$t('getapi[1340]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="inv_measure_receivable_qty"
                                              :title="$t('getapi[1878]')" sortable align="right" width="100"></vxe-table-column>
                            <vxe-table-column field="inv_measure_actually_qty"
                                              :title="$t('getapi[1879]')" sortable align="right" width="100">
                                <template slot-scope="scope">
                                    <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                              v-model="scope.row.inv_measure_actually_qty" @change="getNotPurInvQty(scope,2)" v-if="dataDetail.InHead.order_status == 0"></el-input>
                                    <span v-if="dataDetail.InHead.order_status != 0">{{scope.row.inv_measure_actually_qty}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="batch_no"
                                              :title="$t('getapi[1763]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="sequence_no"
                                              :title="$t('getapi[1764]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column field="expiry_date" :title="$t('getapi[1880]')" sortable width="100">
                                <template slot-scope="scope">
                                    <el-date-picker size="mini" v-model="scope.row.expiry_date" type="date"
                                                    class="mcolor"
                                                    value-format="yyyy/MM/dd"
                                                    style="width:100%"
                                                    v-if="scope.row.keep_period_flag == true"></el-date-picker>
                                    <span v-if="scope.row.keep_period_flag == false">{{scope.row.expiry_date}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="unit_price" :title="$t('getapi[1410]')" sortable align="right" v-if="authority_showprice">
                                <!--<template scope="scope" v-if="dataDetail.InHead.order_status == 0">
                                    <el-input size="mini" type="number" autocomplete="off" title="" v-model="scope.row.unit_price"></el-input>
                                </template>-->
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="line_total_amount" :title="$t('getapi[6937]')" sortable
                                              align="right" v-if="authority_showprice" width="100">
                                <!-- <template scope="scope" v-if="dataDetail.InHead.order_status == 0">
                                     <el-input size="mini" type="number" autocomplete="off" title=""
                                               v-model="scope.row.line_total_amount"></el-input>
                                 </template>-->
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="line_tax_amount" :title="$t('getapi[1598]')" sortable
                                              align="right" v-if="authority_showprice" width="100">
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="line_remark"  v-if="showLineRemark" :title="$t('getapi[4279]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="createinvoiceqty" :title="$t('getapi[1884]')" sortable
                                              align="right" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="releaseinvoiceqty" :title="$t('getapi[1885]')" sortable
                                              align="right" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="consumption_date"
                                              :title="$t('getapi[1512]')" sortable width="100"></vxe-table-column>
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[1886]')" name="1" id="xdetilpane-1">
                        <div class="btnnowrap">
                            <el-button type="primary" size="mini" @click="importPart()" :disabled="!btn.ImportPart">
                                {{$t('getapi[7929]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click="showAddAssisBom('')" :disabled="!btn.Assis_AddDetail">{{ $t('getapi[6092]')
                                }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="batchDelAssis" :disabled="!btn.Assist_rowdel">{{ $t('getapi[1522]') }}
                            </el-button>
                        </div>
                        <vxe-table :data="dataDetail.HasAssistList" :row-class-name="tableRowClassNameHas"
                                   @checkbox-change="handleSelectionChangeAssis"
                                   style="width: 100%; margin-top:3px" :highlight-current-row="true"
                                   :height="tableHeight - 245"
                                   size="mini" border
                                   resizable
                                   show-overflow="tooltip"
                                   header-row-class-name="headerclass"
                                   @sort-change="sortChangeAssis"
                                   :default-sort="sortRule"
                                   ref="singleTable2">
                            <vxe-table-column type="checkbox" align="center"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="line_no" :title="$t('getapi[1425]')" sortable
                                              align="right" width="50"></vxe-table-column>
                            <vxe-table-column field="relation_regist_order_no"
                                              :title="$t('getapi[1874]')" sortable width="150">
                                <template slot-scope="scope">
                                    <el-input
                                            v-model="scope.row.relation_regist_order_no"
                                            type="text"
                                            v-if="dataDetail.InHead.order_status == 0"
                                            size="mini"
                                            readonly
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="showAddAssisBom(scope)"></i>
                                    </el-input>
                                    <span v-if="dataDetail.InHead.order_status != 0">{{scope.row.relation_regist_order_no}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="relation_regist_order_line_no"
                                              :title="$t('getapi[1875]')" sortable align="right" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="delive_order_no"
                                              :title="$t('getapi[1744]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="category_firstname"
                                              :title="$t('getapi[169]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="category_secondname"
                                              :title="$t('getapi[170]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="category_thirdname"
                                              :title="$t('getapi[171]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_code"
                                              :title="$t('getapi[112]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_version"
                                              :title="$t('getapi[149]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_name"
                                              :title="$t('getapi[116]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="application_department"
                                              :title="$t('getapi[6041]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column field="cargoposition_code"
                                              :title="$t('getapi[1882]')" sortable width="120">
                                <template slot-scope="scope">
                                    <el-input
                                            v-model="scope.row.cargoposition_code"
                                            type="text"
                                            v-if="dataDetail.InHead.order_status == 0"
                                            size="mini"
                                            readonly
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="showPurCargoAssis(scope)"></i>
                                    </el-input>
                                    <span v-if="dataDetail.InHead.order_status != 0">{{scope.row.cargoposition_code}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_finance_type"
                                              :title="$t('getapi[119]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_stuff"
                                              :title="$t('getapi[126]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_model"
                                              :title="$t('getapi[124]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_spec"
                                              :title="$t('getapi[125]')" sortable width="100"></vxe-table-column>                            
                            <vxe-table-column show-footer-overflow field="freevalue"
                                              :title="$t('getapi[8958]')" sortable width="100"></vxe-table-column>                           
                            <vxe-table-column show-footer-overflow field="pur_measure"
                                              :title="$t('getapi[1166]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="pur_measure_receivable_qty"
                                              :title="$t('getapi[1876]')" sortable align="right" width="100"></vxe-table-column>
                            <vxe-table-column field="pur_measure_actually_qty"
                                              :title="$t('getapi[1877]')" sortable align="right" width="100">
                                <template slot-scope="scope">
                                    <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                              v-model="scope.row.pur_measure_actually_qty" @change="getPurOInvQty(scope, 1)" v-if="dataDetail.InHead.order_status == 0"></el-input>
                                    <span v-if="dataDetail.InHead.order_status != 0">{{scope.row.pur_measure_actually_qty}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="exchange_rate"
                                              :title="$t('getapi[3599]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="inv_measure"
                                              :title="$t('getapi[1340]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="inv_measure_receivable_qty"
                                              :title="$t('getapi[1878]')" sortable align="right" width="100"></vxe-table-column>
                            <vxe-table-column field="inv_measure_actually_qty"
                                              :title="$t('getapi[1879]')" sortable align="right" width="100">
                                <template slot-scope="scope">
                                    <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                              v-model="scope.row.inv_measure_actually_qty" @change="getPurOInvQty(scope, 2)" v-if="dataDetail.InHead.order_status == 0"></el-input>
                                    <span v-if="dataDetail.InHead.order_status != 0">{{scope.row.inv_measure_actually_qty}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="assist_measure_receivable_qty"
                                              :title="$t('getapi[1887]')" sortable align="right" width="100"></vxe-table-column>
                            <vxe-table-column field="assist_measure_actually_qty"
                                              :title="$t('getapi[1888]')" sortable align="right" width="100">
                                <template slot-scope="scope">
                                    <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                              v-model="scope.row.assist_measure_actually_qty" @input="getPurAInvQty(scope)" v-if="dataDetail.InHead.order_status == 0"></el-input>
                                    <span v-if="dataDetail.InHead.order_status != 0">{{scope.row.assist_measure_actually_qty}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="assist_measure"
                                              :title="$t('getapi[130]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="batch_no"
                                              :title="$t('getapi[1763]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="sequence_no"
                                              :title="$t('getapi[1764]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column field="expiry_date" :title="$t('getapi[1880]')" sortable width="100">
                                <template slot-scope="scope">
                                    <el-date-picker size="mini" v-model="scope.row.expiry_date" type="date"
                                                    class="mcolor"
                                                    value-format="yyyy/MM/dd"
                                                    style="width:100%"
                                                    v-if="scope.row.keep_period_flag == true"></el-date-picker>
                                    <span v-if="scope.row.keep_period_flag == false">{{scope.row.expiry_date}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="unit_price" :title="$t('getapi[1410]')" sortable align="right" v-if="authority_showprice" width="100">
                                <!-- <template scope="scope" v-if="dataDetail.InHead.order_status == 0">
                                     <el-input size="mini" type="number" autocomplete="off" title="" v-model="scope.row.unit_price"></el-input>
                                 </template>-->
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="line_total_amount" :title="$t('getapi[6937]')" sortable
                                              align="right" v-if="authority_showprice" width="100">
                                <!--<template scope="scope" v-if="dataDetail.InHead.order_status == 0">
                                    <el-input size="mini" type="number" autocomplete="off" title=""
                                              v-model="scope.row.line_total_amount"></el-input>
                                </template>-->
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="line_tax_amount" :title="$t('getapi[1598]')" sortable
                                              align="right" v-if="authority_showprice" width="100">
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="line_remark" v-if="showLineRemark"
                                              :title="$t('getapi[4279]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="createinvoiceqty" :title="$t('getapi[1884]')" sortable
                                              align="right" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="releaseinvoiceqty" :title="$t('getapi[1885]')" sortable
                                              align="right" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="consumption_date"
                                              :title="$t('getapi[1512]')" sortable width="100"></vxe-table-column>
                        </vxe-table>
                    </el-tab-pane>
                </el-tabs>
                <div style="width:420px">
                    <table>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[1890]') }}</td>
                            <td style="width:150px">
                                <el-input v-model="dataDetail.InHead.create_person" type="text" size="mini"
                                          style="width:100%" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[4043]') }}</td>
                            <td style="width:150px">
                                <el-input v-model="dataDetail.InHead.audit_person" type="text" size="mini"
                                          style="width:100%" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[3691]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.InHead.create_date" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>{{ $t('getapi[3692]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.InHead.audit_date" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                        </tr>
                    </table>
                </div>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>

        <serce :isVisible="isVisible" queryData="PurReceiveInHeadViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[957]')" queryData="PurReceiveInHeadViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!--采购订单-->
        <!--<order :isVisible="orderVisible" @getorder="getorder" ref="order"></order>-->
        <selector :isVisible="orderVisible" :isBatch=false :selectType="1" :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetPurOrderDataList'" @callback="getorder" ref="order"></selector>
        <!--采购订单-->
        <!--<grnorder :isVisible="itemVisible" @getgrnorder="getgrnorder" ref="input"></grnorder>-->
        <!-- 物料多选 -->
        <selector :isVisible="itemVisible" :isBatch=true :selectType="0" :isSplitPage=true
                  :postUrl="'/Pur/GRN/GetPurGRNOrderNoPopupList'" @callback="getgrnorder" ref="input"></selector>
        <!-- 物料单选 -->
        <selector :isVisible="itemVisible" :isBatch=false :selectType="0" :isSplitPage=true
                  :postUrl="'/Pur/GRN/GetPurGRNOrderNoPopupList'" @callback="getgrnorder" ref="inputsingle"></selector>
        <!-- 物料多选 -->
        <selector :isVisible="itemVisible" :isBatch=true :selectType="1" :isSplitPage=true
                  :postUrl="'/Pur/GRN/GetPurGRNOrderNoPopupList'" @callback="getgrnorder" ref="inputassis"></selector>
        <!-- 物料单选 -->
        <selector :isVisible="itemVisible" :isBatch=false :selectType="1" :isSplitPage=true
                  :postUrl="'/Pur/GRN/GetPurGRNOrderNoPopupList'" @callback="getgrnorder"
                  ref="inputassissingle"></selector>
        <!--人员-->
        <!--<employee :isVisible="employeeVisible" @getemployee="getemployee" ref="employee"></employee>-->
        <selector :isVisible="employeeVisible" :isBatch=false :selectType="3" :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getemployee" ref="employee"></selector>
        <!--货位代码-->
        <!--<purcargo :isVisible="purcargoVisible" @getpurcargo="getpurcargo" ref="purcargo"></purcargo>-->
        <selector :isVisible="purcargoVisible" :isBatch=false :selectType="0" :isSplitPage=true
                  :postUrl="'/Pur/GRN/GetPurGRNCargoPPopupList'" @callback="getpurcargo" ref="purcargo"></selector>

        <el-dialog v-dialogDrag :visible.sync="showCollsoPrint" :title="$t('getapi[34]')" width="300px" :close-on-click-modal="false">
            <el-divider></el-divider>
            <div>
                <table>
                    <tr>
                        <td>{{$t('getapi[12749]')}}</td>
                        <td>
                            <el-select v-model="printerid" class="select" @change="changePrinter">
                                <el-option v-for="item in printerArr" :key="item.id" :label="item.name"
                                           :value="item.id"></el-option>
                            </el-select>
                        </td>
                        <td><el-button type="primary" @click="editPrinter" size="mini">{{ $t('getapi[34]') }}</el-button></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[12868]')}}</td>
                        <td>
                            <el-input v-model="copies" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                        </td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="showCollsoPrint = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="mini" type="primary" @click="confirmCollsoPrint">{{$t('getapi[1146]')}}{{$t('getapi[940]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="showPrinter" :title="$t('getapi[34]')" width="40%" :close-on-click-modal="false">
            <el-divider></el-divider>
            <div>
                <div>
                    <el-button type="primary" size="mini" @click="addPrinter">{{
                        $t('getapi[878]') }}
                    </el-button>
                </div>
                <el-table
                        :data="printerArr"
                        :highlight-current-row="true"
                        :height="300"
                        header-row-class-name="headerclass"
                        border
                        size="mini"
                        style="width: 100%; margin-top:2px"
                >
                    <el-table-column show-overflow-tooltip prop="ip" :label="$t('getapi[12750]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="model" :label="$t('getapi[12751]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="name" :label="$t('getapi[12752]')"></el-table-column>
                    <el-table-column fixed="right" :label="$t('getapi[6048]')" width="150">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="editPrinter_(scope)" type="text" size="small">{{
                                $t('getapi[34]') }}
                            </el-button>
                            <el-popconfirm
                                    :confirmButtonText="$t('getapi[6109]')"
                                    :cancelButtonText="$t('getapi[6]')"
                                    icon="el-icon-info"
                                    iconColor="red"
                                    :title="$t('getapi[637]')"
                                    @onConfirm="delPrinter_(scope)"
                            >
                                <el-button slot="reference" type="text" size="small">{{ $t('getapi[40]')
                                    }}
                                </el-button>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-divider></el-divider>

            <span slot="footer" class="dialog-footer">
				<el-button  @click="showPrinter = false" size="mini">{{ $t('getapi[6]') }}</el-button>
			</span>
        </el-dialog>
        <el-dialog v-dialogDrag :visible.sync="isShowDialog" :title="titleinfo" width="25%" :close-on-click-modal="false">
			<el-input type="textarea" :autosize="{ minRows: 15}"  v-model="content"></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowDialog = false">{{ $t('getapi[2054]') }}</el-button>
				<!-- <el-button type="primary" @click="confirm" size="mini" >{{$t('getapi[1146]')}}</el-button> -->
			</span>
		</el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';

    export default {
        name: 'purgrnview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader:[],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('purgrnview'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                isShowEdit: false, // 是否显示编辑页面
                dataDetail: {
                    InHead: {},
                    NotAssistList: [],
                    HasAssistList: []
                }, // 编辑页面数据详情
                oldDataDetail: '',
                order_No: '',
                UseArray: [
                    {
                        Code: '入库',
                        Name: '入库'
                    },
                    {
                        Code: '调账',
                        Name: '调账'
                    }
                ], // 计划类型数组
                orderVisible: false, //

                addoredit: -1, // 1.新增2：编辑
                oneormore: -1, // 1:单选2：多选
                rowindex: -1,
                oneormoreassis: -1, // 1:单选2：多选
                rowindexassis: -1,
                grnOrderType: 1, // 1:主物料2：次物料
                selectData: [],
                selectDataAssis: [],
                itemVisible: false,
                itemAssisVisible: false,

                nowPOCode: 0, // 当前单号
                employeeVisible: false,
                employeeType: 1, //1保管员2记账员

                purcargoVisible: false,
                purcargoType: 1, //1:一般物料2：此物料
                btn: {
                    //导入
                    ImportPart: false,
                    //审核
                    Audit: false,
                    //记账
                    Balance: false,
                    //反记账
                    RBalance: false,
                    //删除明细
                    rowdel: false,
                    //次计量明细删除
                    Assist_rowdel: false,
                    //一般物料添加
                    AddDetail:false,
                    //次计量添加
                    Assis_AddDetail:false,
                    remark:false,
                },
                authority_showprice: false,
                //一览金额是否显示
                view_authority_showprice: false,
                updateInvQty: false,
                //行备注显影
                showLineRemark:false,
                showRemarkNmae:"显示行备注",
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                RightSelectIndex: '0',
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                showCollsoPrint:false,
                printerid:'',
                selectPrinterDetail:{
                    id:'',
                    ip:'',
                    model:'',
                    name:''
                },
                printerArr:[],
                copies:1,
                showPrinter:false,
                showEditPrinter:false,
                printerDetail:{
                    id:'',
                    ip:'',
                    model:'',
                    name:''
                },
                addoreditprint: 1,//1新增2编辑
                sortRule: {property:null,order:null},
                isShowDialog: false,
                content:'',
                titleinfo:'',
                priceDigit:this.$store.state.digitsetting.pur_price_digit,
                amountDigit:this.$store.state.digitsetting.pur_amount_digit,
            };
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'purbusiness' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getDetail(data.order_no, 1);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.bodyWrapper.scrollTop =this.scrollTop2;
                }, 13)
            })
        },
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(0)
                })
            },
            dataDetail: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(this.RightSelectIndex)
                })
            }
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('purgrnview', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.user = that.userData.username;
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd();
        },
        methods: {
            tableRowClassNameHas({row, rowIndex}) {
                row.index = rowIndex;
            },
            tableRowClassNameNot({row, rowIndex}) {
                row.index = rowIndex;
            },
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('PurReceiveInHeadViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[957]"),this.$t("getapi[16]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if(that.$limits.authority('plv4', 260, 1) ==  1){
                    that.authority_showprice = true
                } else {
                    that.authority_showprice = false
                }

                if(that.$limits.authority('plv4', 309, 1) ==  1){
                    that.view_authority_showprice = true
                } else {
                    that.view_authority_showprice = false
                }
               
                //管理界面
                if (that.$limits.authority('plv2', 215, 1) == 1) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                else if (that.$limits.authority('plv2', 215, 1) == 2) {
                    if (that.$limits.authority('plv3', 215,1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 215,1) == 1) {
                        //编辑级
                        if (!that.$limits.fnIsEmpty(that.dataDetail.InHead.order_no)) {
                            if (that.dataDetail.InHead.order_status == 0) {
                                if (that.$limits.authority('plv4', 148, 1) > 0) {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print,execute');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                            }
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                    }
                    if (that.$limits.authority('plv3', 215, 1) == 2) {
                        //删除级
                        if (!that.$limits.fnIsEmpty(that.dataDetail.InHead.order_no)) {
                            if (that.dataDetail.InHead.order_status > 0) {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                            } else {
                                if (that.$limits.authority('plv4', 148, 1) > 0) {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export,print,execute');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export,print');
                                }
                            }
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                    }
                }
                else{
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    if (that.$limits.authority('plv2', 214, 1) > 0) {
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                    }
                }

                if (that.dataDetail.InHead.order_status > 0) {
                    if(that.$limits.authority('plv4', 565, 1) >= 1){
                        that.updateInvQty = true
                    } else {
                        that.updateInvQty = false
                    }
                }
                if(that.dataDetail.InHead.order_status ==1){
                    that.$refs.SetBtn.SetOneBtnEnable('save', false)
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                //导入
                that.btn.ImportPart = false;
                //审核
                that.btn.Audit = false;
                //记账
                that.btn.Balance = false;
                //反记账
                that.btn.RBalance = false;
                //一般物料添加
                that.btn.AddDetail=false;
                //次计量添加
                that.btn.Assis_AddDetail=false;
                //删除明细
                that.btn.rowdel = false;
                that.btn.Assist_rowdel = false;
                that.btn.remark=false;
                if (that.$limits.authority('plv4', 154, 1) == 1) {
                    that.btn.remark=true ;
                }
                else{
                    that.btn.remark=false;
                }
                if (that.dataDetail.InHead.order_status == 0) {
                    //一般物料添加
                    that.btn.AddDetail=true;
                    //次计量添加
                    that.btn.Assis_AddDetail=true;

                    if (that.selectData.length > 0) {
                        if (that.dataDetail.InHead.finance_status != 2) {
                            //不等于月结
                            //删除明细
                            that.btn.rowdel = true;
                        }
                    }
                    if (that.selectDataAssis.length > 0) {
                        if (that.dataDetail.InHead.finance_status != 2) {
                            //不等于月结
                            //删除明细
                            that.btn.Assist_rowdel = true;
                        }
                    }

                }

                if (that.$limits.fnIsEmpty(that.dataDetail.InHead.order_no)) {
                    //导入
                    that.btn.ImportPart = true;
                } else {
                    //单据状态
                    if (that.dataDetail.InHead.order_status == 0) {
                        //生成
                        //导入
                        that.btn.ImportPart = false;
                        //审核
                        that.btn.Audit = true;
                        //记账
                        that.btn.Balance = false;
                        //反记账
                        that.btn.RBalance = false;
                    }
                    if (that.dataDetail.InHead.order_status == 1) {
                        //审核
                        //导入
                        that.btn.ImportPart = false;
                        //审核
                        that.btn.Audit = false;
                        //记账
                        that.btn.Balance = false;
                        //反记账
                        that.btn.RBalance = false;
                    }
                    if (that.dataDetail.InHead.order_status == 2) {
                        //作废
                        //导入
                        that.btn.ImportPart = false;
                        //审核
                        that.btn.Audit = false;
                        //记账
                        that.btn.Balance = false;
                        //反记账
                        that.btn.RBalance = false;
                    }
                    // console.log("财务状态:"+that.dataDetail.InHead.finance_status);
                    //财务状态
                    if (that.dataDetail.InHead.finance_status == 0) {
                        //核算
                        //导入
                        that.btn.ImportPart = false;
                        //审核
                        that.btn.Audit = false;
                        //记账
                        that.btn.Balance = true;
                        //反记账
                        that.btn.RBalance = false;
                    }
                    if (that.dataDetail.InHead.finance_status == 1) {
                        //记账
                        //导入
                        that.btn.ImportPart = false;
                        //审核
                        that.btn.Audit = false;
                        //记账
                        that.btn.Balance = false;
                        //反记账
                        that.btn.RBalance = true;
                    }
                    if (that.dataDetail.InHead.finance_status == 2) {
                        //月结
                        //导入
                        that.btn.ImportPart = false;
                        //审核
                        that.btn.Audit = false;
                        //记账
                        that.btn.Balance = false;
                        //反记账
                        that.btn.RBalance = false;
                    }
                }

                //权限控制
                if (that.btn.ImportPart == true) {
                    if (that.$limits.authority('plv4', 145, 1) == 1) {
                        that.btn.ImportPart = true;
                    } else {
                        that.btn.ImportPart = false;
                    }
                }

                if (that.btn.Audit == true) {
                    if (that.$limits.authority('plv4', 148, 1) == 1) {
                        that.btn.Audit = true;
                    } else {
                        that.btn.Audit = false;
                    }
                }
                if (that.btn.Balance == true) {
                    if (that.$limits.authority('plv4', 150, 1) == 1) {
                        that.btn.Balance = true;
                    } else {
                        that.btn.Balance = false;
                    }
                }
                if (that.btn.RBalance == true) {
                    if (that.$limits.authority('plv4', 151, 1) == 1) {
                        that.btn.RBalance = true;
                    } else {
                        that.btn.RBalance = false;
                    }
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            showRemark(){
                let that=this;
                if(that.showLineRemark){
                    that.showRemarkNmae="显示行备注"
                    that.showLineRemark=false
                }
                else{
                    that.showRemarkNmae="隐藏行备注";
                    that.showLineRemark=true
                }
            },
            keyup(ev, row) {
                let that = this;
                that.editInfo(row);
            },
            keydown(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = that.dataSet[index - 1];
                    that.setCurrent(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = that.dataSet[index + 1];
                    that.setCurrent(tds);
                }
            },
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            handleCurrentChanges(val) {
                if (val != null) {
                    let result = this.dataSet.findIndex(item => item.PO_Code === val.PO_Code);
                    let fsd = document.getElementsByClassName('fsd');
                    fsd[result].focus();
                    this.currentRow = val;
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('purgrnview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'PurReceiveInHeadViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Pur/GRN/DataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                if(that.order_No == row.Order_No){
                    return
                }
                that.timeId = setTimeout(() => {
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.NotAssistList.length;i++){
                        delete datacopy.NotAssistList[i]['index']
                        delete datacopy.NotAssistList[i]['_XID'];
                    }
                    for(let i = 0;i<datacopy.HasAssistList.length;i++){
                        delete datacopy.HasAssistList[i]['index']
                        delete datacopy.HasAssistList[i]['_XID'];
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.isShowEdit = true;
                                that.order_No = row.Order_No;
                                that.nowPOCode = row.Order_No;
                                that.getDetail(row.Order_No);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.isShowEdit = true;
                        that.order_No = row.Order_No;
                        that.nowPOCode = row.Order_No;
                        that.getDetail(row.Order_No);
                    }
                }, 100);
            },
            // 获取详情数据
            getDetail(order_No) {
                let that = this;
                if (that.$limits.authority('plv2', 215, 1) <1) {
                    return;
                }
                that.addoredit = 2
                if(that.$limits.fnIsEmpty(order_No)){
                    that.$message.warning(that.$t('getapi[8619]'));//单据号不能为空
                    return;
                }

                let parm = {
                    Code: order_No
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Pur/GRN/GetPurReceiveInBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.selectData = [];
                        that.selectDataAssis = [];
                        that.order_No = that.dataDetail.InHead.order_no;
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                        that.btnauthority();
                    }
                    loadingInstance.close()
                });
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.NotAssistList.length;i++){
                    delete datacopy.NotAssistList[i]['index']
                    delete datacopy.NotAssistList[i]['_XID'];
                }
                for(let i = 0;i<datacopy.HasAssistList.length;i++){
                    delete datacopy.HasAssistList[i]['index']
                    delete datacopy.HasAssistList[i]['_XID'];
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                let datetime = Common.methods.getDatetime()
                let date = Common.methods.getDate();
                that.addoredit = 1;
                that.isShowEdit = true;
                that.order_No = ''
                that.dataDetail = {
                    InHead: {
                        order_no: '',
                        po_code: '',
                        purchase_person: '',
                        payment_mode: '',
                        finance_date: '',
                        create_person: '',
                        create_date: '',
                        audit_person: '',
                        audit_date: '',
                        order_status: 0,
                        finance_status: -1,
                        total_amount: 0,
                        remark: '',
                        versioncode: '',
                        versionname: '',
                        keep_person: that.user,
                        regist_person: that.user,
                        modify_person: '',
                        modify_time: '',
                        invoice_flag: 0,
                        tax_rate:0.0,
                        taxcode:'',
                        order_category: that.$limits.getDefaultSelect(that.UseArray, 'Code')
                    },
                    NotAssistList: [],
                    HasAssistList: []
                };
                that.dataDetail = {...that.dataDetail};
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                /*let that = this;
                that.getView();
                if (that.addoredit != 1) {
                    that.getDetail(that.order_No);
                } else {
                    that.add()
                }*/
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.NotAssistList.length;i++){
                    delete datacopy.NotAssistList[i]['index']
                    delete datacopy.NotAssistList[i]['_XID'];
                }
                for(let i = 0;i<datacopy.HasAssistList.length;i++){
                    delete datacopy.HasAssistList[i]['index']
                    delete datacopy.HasAssistList[i]['_XID'];
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.addoredit != 1){
                                that.getView();
                                that.getDetail(that.order_No)
                            } else {
                                that.getView();
                                that.confirmAdd()
                            }
                        });
                } else {
                    if(that.addoredit != 1){
                        that.getView();
                        that.getDetail(that.order_No)
                    } else {
                        that.getView();
                        that.confirmAdd()
                    }
                }
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps', false);
                that.$http.urlpost('/Pur/GRN/ExportToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps', true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "PurReceiveInHeadViewInfo",
                    fromname: that.$t('getapi[957]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                let parm = that.dataDetail;
                parm.LangType = that.$processdata.getLang()
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                for (let i = 0; i < that.dataDetail.NotAssistList.length; i++) {
                    that.dataDetail.NotAssistList[i].keep_period_flag = that.dataDetail.NotAssistList[i].keep_period_flag == false ? 0 : 1;
                    that.dataDetail.NotAssistList[i].issequencetrace = that.dataDetail.NotAssistList[i].issequencetrace == false ? 0 : 1;
                }
                for (let i = 0; i < that.dataDetail.HasAssistList.length; i++) {
                    that.dataDetail.HasAssistList[i].keep_period_flag = that.dataDetail.HasAssistList[i].keep_period_flag == false ? 0 : 1;
                    that.dataDetail.HasAssistList[i].issequencetrace = that.dataDetail.HasAssistList[i].issequencetrace == false ? 0 : 1;
                }
                that.$http.urlpost('/Pur/GRN/SaveData', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.nowPOCode = res.UniqueNum;
                        that.order_No = res.UniqueNum;
                        that.getDetail(that.order_No);
                    }
                });
            },
            //获取采购订单
            selectOrder() {
                let that = this;
                if(that.dataDetail.NotAssistList.length > 0 || that.dataDetail.HasAssistList.length > 0){
                    return
                }
                that.orderVisible = true;
                that.$refs.order.clearInput(this.orderVisible);
            },
            // 获取订单信息
            getorder(data) {
                let that = this;
                console.log(data)
                let datetime = Common.methods.getDatetime()
                let date = (new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()).toString();
                that.dataDetail.InHead.payment_mode = data.payment_mode;
                that.dataDetail.InHead.po_code = data.po_code;
                that.dataDetail.InHead.versioncode = data.vender_code;
                that.dataDetail.InHead.versionname = data.vender_name;
                that.dataDetail.InHead.purchase_person = data.transact_person;
                that.dataDetail.InHead.taxcode = data.taxcode;
                that.dataDetail.InHead.tax_rate = data.tax_rate;
                that.dataDetail = {...that.dataDetail};
            },
            //获取一般物料与次计量管理物料最大行号
            getMaxLineNo()
            {
                let that = this;
                var ReturnInt = 0;
                for (var i = 0; i < that.dataDetail.HasAssistList.length; i++)
                {
                    if (that.dataDetail.HasAssistList[i].line_no > ReturnInt)
                    {
                        ReturnInt =that.dataDetail.HasAssistList[i].line_no;
                    }
                }

                for (var j = 0; j < that.dataDetail.NotAssistList.length; j++)
                {
                    if (that.dataDetail.NotAssistList[j].line_no > ReturnInt)
                    {
                        ReturnInt = that.dataDetail.NotAssistList[j].line_no;
                    }
                }
                return ReturnInt + 1;
            },
            // 新增物料
            showAddBom(row) {
                let that = this;
                if(that.dataDetail.InHead.po_code == '' || that.dataDetail.InHead.po_code == null){
                    that.$message.warning(that.$t('getapi[8743]'));//'订单号不能为空'
                    return
                }
                that.grnOrderType = 1
                that.itemVisible = true;
                if (row == '') {
                    that.rowindex = row.$rowIndex;
                    that.oneormore = 1;
                    let param = {
                        po_code: that.dataDetail.InHead.po_code,
                        taxcode: that.dataDetail.InHead.taxcode,
                        tax_rate: that.dataDetail.InHead.tax_rate
                    }
                    that.$refs.input.clearInput(that.itemVisible, param);
                } else {
                    that.oneormore = 2;
                    let param = {
                        po_code: that.dataDetail.InHead.po_code,
                        taxcode: that.dataDetail.InHead.taxcode,
                        tax_rate: that.dataDetail.InHead.tax_rate
                    }
                    that.$refs.input.clearInput(that.itemVisible, param);
                }
            },
            showAddAssisBom(row) {
                let that = this;
                that.grnOrderType = 2
                that.itemAssisVisible = true;
                if (row == '') {
                    that.oneormoreassis = 1;
                    let param = {
                        po_code: that.dataDetail.InHead.po_code,
                        taxcode: that.dataDetail.InHead.taxcode,
                        tax_rate: that.dataDetail.InHead.tax_rate
                    }
                    that.$refs.inputassis.clearInput(that.itemAssisVisible, param);
                } else {
                    that.oneormoreassis = 2;
                    that.rowindexassis = row.$rowIndex;
                    let param = {
                        po_code: that.dataDetail.InHead.po_code,
                        taxcode: that.dataDetail.InHead.taxcode,
                        tax_rate: that.dataDetail.InHead.tax_rate
                    }
                    that.$refs.inputassissingle.clearInput(that.itemAssisVisible, param);
                }
            },

            // 获取物料信息
            getgrnorder(data) {
                let that = this;
                console.log(data)
                if (that.grnOrderType == 1) {
                    if (that.oneormore == 1) {
                        if (that.dataDetail.NotAssistList.length > 0) {
                            data = data.filter(item => {
                                return that.dataDetail.NotAssistList.every(item2 => {
                                    return item.receive_order_no + item.receive_order_line_no != item2.relation_regist_order_no + item2.relation_regist_order_line_no
                                })
                            })
                        }
                        for (let i = 0; i < data.length; i++) {
                            that.dataDetail.NotAssistList = [
                                ...that.dataDetail.NotAssistList,
                                {
                                    relation_order_no: '',
                                    // line_no: that.dataDetail.NotAssistList.length + 1,
                                    line_no:that.getMaxLineNo(),
                                    relation_regist_order_no: data[i].receive_order_no,
                                    relation_regist_order_line_no: data[i].receive_order_line_no,
                                    category_firstname: '',
                                    category_secondname: '',
                                    category_thirdname: '',
                                    part_code: data[i].part_code,
                                    part_version: data[i].part_version,
                                    part_name: data[i].part_name,
                                    part_model: data[i].model,
                                    part_spec: data[i].specification,
                                    part_stuff:data[i].part_stuff,
                                    pur_measure: data[i].pur_measureunit,
                                    pur_measure_receivable_qty: data[i].jyhgqty,
                                    pur_measure_actually_qty: data[i].jyhgqty,
                                    exchange_rate: data[i].exchange_rate,
                                    inv_measure: data[i].part_master_unit,
                                    inv_measure_receivable_qty: data[i].mainjyhgqty,
                                    inv_measure_actually_qty: data[i].mainjyhgqty,
                                    batch_no: data[i].batch_no,
                                    sequence_no: data[i].sequence_no,
                                    unit_price: data[i].line_net_unitprice_base.toFixed(that.priceDigit),
                                    line_total_amount: data[i].line_net_amount.toFixed(that.amountDigit),
                                    line_tax_amount: data[i].line_tax_amount.toFixed(that.amountDigit),
                                    application_department: data[i].application_department,
                                    cargoposition_code: data[i].cargoposition_code,
                                    line_remark: data[i].remark,
                                    delive_order_no: data[i].delive_order_no,
                                    part_finance_type: data[i].financetype,
                                    expiry_date: '',
                                    po_line_id: 0,
                                    keep_period_flag: data[i].keep_period_flag,
                                    issequencetrace: data[i].issequencetrace,
                                    assist_measure: data[i].assist_unit_flag,
                                    assist_measure_receivable_qty: 0,
                                    assist_measure_actually_qty: 0,
                                    consumption_date: data[i].consumption_date,
                                    releaseinvoiceqty: 0,
                                    createinvoiceqty: 0,
                                    part_groupid: data[i].part_groupid,
                                    freevalue: data[i].freevalue,
                                }
                            ];
                        }
                    } else if (that.oneormore == 2) {
                        for(let i = 0;i < that.dataDetail.NotAssistList.length;i++){
                            if(data.receive_order_no + data.receive_order_line_no == that.dataDetail.NotAssistList[i].relation_regist_order_no + that.dataDetail.NotAssistList[i].relation_regist_order_line_no){
                                return
                            }
                        }
                        that.dataDetail.NotAssistList[that.rowindex].relation_order_no = '',
                            /*line_no= "",*/
                            that.dataDetail.NotAssistList[that.rowindex].relation_regist_order_no = data.receive_order_no,
                            that.dataDetail.NotAssistList[that.rowindex].relation_regist_order_line_no = data.receive_order_line_no,
                            that.dataDetail.NotAssistList[that.rowindex].category_firstname = '',
                            that.dataDetail.NotAssistList[that.rowindex].category_secondname = '',
                            that.dataDetail.NotAssistList[that.rowindex].category_thirdname = '',
                            that.dataDetail.NotAssistList[that.rowindex].part_code = data.part_code,
                            that.dataDetail.NotAssistList[that.rowindex].part_version = data.part_version,
                            that.dataDetail.NotAssistList[that.rowindex].part_name = data.part_name,
                            that.dataDetail.NotAssistList[that.rowindex].part_model = data.model,
                            that.dataDetail.NotAssistList[that.rowindex].part_spec = data.specification,
                            that.dataDetail.NotAssistList[that.rowindex].part_stuff = data.part_stuff,
                            that.dataDetail.NotAssistList[that.rowindex].pur_measure = data.pur_measureunit,
                            that.dataDetail.NotAssistList[that.rowindex].pur_measure_receivable_qty = data.jyhgqty,
                            that.dataDetail.NotAssistList[that.rowindex].pur_measure_actually_qty = data.jyhgqty,
                            that.dataDetail.NotAssistList[that.rowindex].exchange_rate = data.exchange_rate,
                            that.dataDetail.NotAssistList[that.rowindex].inv_measure = data.part_master_unit,
                            that.dataDetail.NotAssistList[that.rowindex].inv_measure_receivable_qty = data.mainjyhgqty,
                            that.dataDetail.NotAssistList[that.rowindex].inv_measure_actually_qty = data.mainjyhgqty,
                            that.dataDetail.NotAssistList[that.rowindex].batch_no = data.batch_no,
                            that.dataDetail.NotAssistList[that.rowindex].sequence_no = data.sequence_no,
                            that.dataDetail.NotAssistList[that.rowindex].unit_price = data.line_net_unitprice_base.toFixed(that.priceDigit),
                            that.dataDetail.NotAssistList[that.rowindex].line_total_amount = data.line_net_amount.toFixed(that.amountDigit),
                            that.dataDetail.NotAssistList[that.rowindex].line_tax_amount = data.line_tax_amount.toFixed(that.amountDigit),
                            that.dataDetail.NotAssistList[that.rowindex].application_department = data.application_department,
                            that.dataDetail.NotAssistList[that.rowindex].cargoposition_code = data.cargoposition_code,
                            that.dataDetail.NotAssistList[that.rowindex].line_remark = data.remark,
                            that.dataDetail.NotAssistList[that.rowindex].delive_order_no = data.delive_order_no,
                            that.dataDetail.NotAssistList[that.rowindex].part_finance_type = data.financetype,
                            that.dataDetail.NotAssistList[that.rowindex].expiry_date = '',
                            that.dataDetail.NotAssistList[that.rowindex].po_line_id = 0,
                            that.dataDetail.NotAssistList[that.rowindex].keep_period_flag = data.keep_period_flag,
                            that.dataDetail.NotAssistList[that.rowindex].issequencetrace = data.issequencetrace,
                            that.dataDetail.NotAssistList[that.rowindex].assist_measure = data.assist_unit_flag,
                            that.dataDetail.NotAssistList[that.rowindex].assist_measure_receivable_qty = 0,
                            that.dataDetail.NotAssistList[that.rowindex].assist_measure_actually_qty = 0,
                            that.dataDetail.NotAssistList[that.rowindex].consumption_date = data.consumption_date,
                            that.dataDetail.NotAssistList[that.rowindex].releaseinvoiceqty = 0,
                            that.dataDetail.NotAssistList[that.rowindex].createinvoiceqty = 0,
                            that.dataDetail.NotAssistList[that.rowindex].part_groupid = data.part_groupid,
                            that.dataDetail.NotAssistList[that.rowindex].freevalue = data.freevalue
                    }
                } else if (that.grnOrderType == 2) {
                    if (that.oneormoreassis == 1) {
                        if (that.dataDetail.HasAssistList.length > 0) {
                            data = data.filter(item => {
                                return that.dataDetail.HasAssistList.every(item2 => {
                                    return item.receive_order_no + item.receive_order_line_no != item2.relation_regist_order_no + item2.relation_regist_order_line_no
                                })
                            })
                        }
                        for (let i = 0; i < data.length; i++) {
                            that.dataDetail.HasAssistList = [
                                ...that.dataDetail.HasAssistList,
                                {
                                    relation_order_no: '',
                                    // line_no: that.dataDetail.HasAssistList.length + 1,
                                    line_no:that.getMaxLineNo(),
                                    relation_regist_order_no: data[i].receive_order_no,
                                    relation_regist_order_line_no: data[i].receive_order_line_no,
                                    category_firstname: '',
                                    category_secondname: '',
                                    category_thirdname: '',
                                    part_code: data[i].part_code,
                                    part_version: data[i].part_version,
                                    part_name: data[i].part_name,
                                    part_model: data[i].model,
                                    part_spec: data[i].specification,
                                    part_stuff: data[i].part_stuff,                                    
                                    pur_measure: data[i].pur_measureunit,
                                    pur_measure_receivable_qty: data[i].jyhgqty,
                                    pur_measure_actually_qty: data[i].jyhgqty,
                                    exchange_rate: data[i].exchange_rate,
                                    inv_measure: data[i].part_master_unit,
                                    inv_measure_receivable_qty: data[i].cijyhgqty,
                                    inv_measure_actually_qty: data[i].cijyhgqty,
                                    batch_no: data[i].batch_no,
                                    sequence_no: data[i].sequence_no,
                                    unit_price: data[i].line_net_unitprice_base.toFixed(that.priceDigit),
                                    line_total_amount: data[i].line_net_unitprice_base1.toFixed(that.amountDigit),
                                    line_tax_amount: data[i].line_tax_amount.toFixed(that.amountDigit),
                                    application_department:data[i].application_department,
                                    cargoposition_code: data[i].cargoposition_code,
                                    line_remark: data[i].remark,
                                    delive_order_no: data[i].delive_order_no,
                                    part_finance_type: data[i].financetype,
                                    expiry_date: '',
                                    po_line_id: 0,
                                    keep_period_flag: data[i].keep_period_flag,
                                    issequencetrace: data[i].issequencetrace,
                                    assist_measure: data[i].part_assist_unit,
                                    assist_measure_receivable_qty: data[i].assist_measure_receivable_qty,
                                    assist_measure_actually_qty: data[i].assist_measure_actually_qty,
                                    consumption_date: data[i].consumption_date,
                                    releaseinvoiceqty: 0,
                                    createinvoiceqty: 0,
                                    part_groupid: data[i].part_groupid,
                                    freevalue: data[i].freevalue,
                                }
                            ];
                        }
                    } else {
                        for(let i = 0;i < that.dataDetail.HasAssistList.length;i++){
                            if(data.receive_order_no + data.receive_order_line_no == that.dataDetail.HasAssistList[i].relation_regist_order_no + that.dataDetail.HasAssistList[i].relation_regist_order_line_no){
                                return
                            }
                        }
                        that.dataDetail.HasAssistList[that.rowindexassis].relation_order_no = '';
                        that.dataDetail.HasAssistList[that.rowindexassis].relation_regist_order_no = data.receive_order_no;
                        that.dataDetail.HasAssistList[that.rowindexassis].relation_regist_order_line_no = data.receive_order_line_no;
                        that.dataDetail.HasAssistList[that.rowindexassis].category_firstname = '';
                        that.dataDetail.HasAssistList[that.rowindexassis].category_secondname = '';
                        that.dataDetail.HasAssistList[that.rowindexassis].category_thirdname = '';
                        that.dataDetail.HasAssistList[that.rowindexassis].part_code = data.part_code;
                        that.dataDetail.HasAssistList[that.rowindexassis].part_version = data.part_version;
                        that.dataDetail.HasAssistList[that.rowindexassis].part_name = data.part_name;
                        that.dataDetail.HasAssistList[that.rowindexassis].part_model = data.model;
                        that.dataDetail.HasAssistList[that.rowindexassis].part_spec = data.specification;
                        that.dataDetail.HasAssistList[that.rowindexassis].part_stuff = data.part_stuff;                        
                        that.dataDetail.HasAssistList[that.rowindexassis].pur_measure = data.pur_measureunit;
                        that.dataDetail.HasAssistList[that.rowindexassis].pur_measure_receivable_qty = data.jyhgqty;
                        that.dataDetail.HasAssistList[that.rowindexassis].pur_measure_actually_qty = data.jyhgqty;
                        that.dataDetail.HasAssistList[that.rowindexassis].exchange_rate = data.exchange_rate;
                        that.dataDetail.HasAssistList[that.rowindexassis].inv_measure = data.part_master_unit;
                        that.dataDetail.HasAssistList[that.rowindexassis].inv_measure_receivable_qty = data.cijyhgqty;
                        that.dataDetail.HasAssistList[that.rowindexassis].inv_measure_actually_qty = data.cijyhgqty;
                        that.dataDetail.HasAssistList[that.rowindexassis].batch_no = data.batch_no;
                        that.dataDetail.HasAssistList[that.rowindexassis].sequence_no = data.sequence_no;
                        that.dataDetail.HasAssistList[that.rowindexassis].unit_price = data.line_net_unitprice_base.toFixed(that.priceDigit);
                        that.dataDetail.HasAssistList[that.rowindexassis].line_total_amount = data.line_net_unitprice_base1.toFixed(that.amountDigit);
                        that.dataDetail.HasAssistList[that.rowindexassis].line_tax_amount = data.line_tax_amount.toFixed(that.amountDigit);
                        that.dataDetail.HasAssistList[that.rowindexassis].application_department = data.application_department;
                        that.dataDetail.HasAssistList[that.rowindexassis].cargoposition_code = data.cargoposition_code;
                        that.dataDetail.HasAssistList[that.rowindexassis].line_remark = data.remark;
                        that.dataDetail.HasAssistList[that.rowindexassis].delive_order_no = data.delive_order_no;
                        that.dataDetail.HasAssistList[that.rowindexassis].part_finance_type = data.financetype;
                        that.dataDetail.HasAssistList[that.rowindexassis].expiry_date = '';
                        that.dataDetail.HasAssistList[that.rowindexassis].po_line_id = 0;
                        that.dataDetail.HasAssistList[that.rowindexassis].keep_period_flag = data.keep_period_flag;
                        that.dataDetail.HasAssistList[that.rowindexassis].issequencetrace = data.issequencetrace;
                        that.dataDetail.HasAssistList[that.rowindexassis].assist_measure = data.part_assist_unit;
                        that.dataDetail.HasAssistList[that.rowindexassis].assist_measure_receivable_qty = data.assist_measure_receivable_qty;
                        that.dataDetail.HasAssistList[that.rowindexassis].assist_measure_actually_qty = data.assist_measure_actually_qty;
                        that.dataDetail.HasAssistList[that.rowindexassis].consumption_date = data.consumption_date;
                        that.dataDetail.HasAssistList[that.rowindexassis].releaseinvoiceqty = 0;
                        that.dataDetail.HasAssistList[that.rowindexassis].createinvoiceqty = 0;
                        that.dataDetail.HasAssistList[that.rowindexassis].part_groupid = data.part_groupid;
                        that.dataDetail.HasAssistList[that.rowindexassis].freevalue = data.freevalue;
                    }
                }
            },
            showPurCargo(row) {
                let that = this;
                that.rowindex = row.$rowIndex;
                that.purcargoVisible = true;
                that.purcargoType = 1;
                that.$refs.purcargo.clearInput(that.purcargoVisible, false, 0);
            },
            showPurCargoAssis(row) {
                let that = this;
                that.rowindexassis = row.$rowIndex;
                that.purcargoVisible = true;
                that.purcargoType = 2;
                that.$refs.purcargo.clearInput(that.purcargoVisible);
            },
            getpurcargo(data) {
                let that = this;
                if (that.purcargoType == 1) {
                    that.dataDetail.NotAssistList[that.rowindex].cargoposition_code = data.cargoposition_code;
                } else if (that.purcargoType == 2) {
                    that.dataDetail.HasAssistList[that.rowindexassis].cargoposition_code = data.cargoposition_code;
                }
            },
            //print
            print() {
                //判断状态
                let that = this;
                let parm = {
                    po_no: that.nowPOCode,
                    TemplateName: '07采购入库单.xlsx'
                };
                that.$http.urlpost('/Print/PRIPrint', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = res.Key;
                        window.open(hrefurl);
                    }
                });
            },
            selectemployee(type) {
                let that = this;
                that.employeeVisible = true;
                that.employeeType = type; // 1保管员2记账员
                that.$refs.employee.clearInput(this.employeeVisible);
            },
            getemployee(data) {
                let that = this;
                if (that.employeeType == 1) {
                    that.dataDetail.InHead.regist_person = data.name;
                } else {
                    that.dataDetail.InHead.keep_person = data.name;
                }
            },
            expStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1422]')//'生成';
                } else if (val == 1) {
                    return that.$t('getapi[941]')//'审核';
                } else if (val == 2) {
                    return that.$t('getapi[1902]')//'作废';
                } else {
                    return '';
                }
            },
            expFinanceStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[941]')//'审核';
                } else if (val == 1) {
                    return that.$t('getapi[3753]')//'记账';
                } else if (val == 2) {
                    return that.$t('getapi[3754]')//'月结';
                } else {
                    return '';
                }
            },
            handleSelectionChange({ records }) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < records.length; i++) {
                    that.selectData.push(records[i]);
                }
                that.btnauthority();
            },
            handleSelectionChangeAssis({ records }) {
                let that = this;
                that.selectDataAssis = [];
                for (let i = 0; i < records.length; i++) {
                    that.selectDataAssis.push(records[i]);
                }
                that.btnauthority();
            },
            batchDel() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.InHead.order_no,
                            modify_time: that.dataDetail.InHead.modify_time,
                            LineList: []
                        };
                        for (let i = that.selectData.length - 1; i >= 0; i--) {
                            that.dataDetail.NotAssistList.splice(that.selectData[i].index, 1);
                            if (that.selectData[i].relation_order_no != "" && that.selectData[i].relation_order_no != null) {
                                let datatmp = {
                                    relation_order_no: that.selectData[i].relation_order_no,
                                    line_no: that.selectData[i].line_no,
                                }
                                parm.LineList.push(datatmp);
                            }
                        }
                        if (parm.LineList.length > 0) {
                            that.btn.rowdel = false
                            that.$http.urlpost('/Pur/GRN/PurGRNGeneraDelLine', parm, function (res) {
                                that.btn.rowdel = true
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.order_No != '') {
                                        that.getDetail(that.order_No);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            batchDelAssis() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.InHead.order_no,
                            modify_time: that.dataDetail.InHead.modify_time,
                            LineList: []
                        };
                        for (let i = that.selectDataAssis.length - 1; i >= 0; i--) {
                            that.dataDetail.HasAssistList.splice(that.selectDataAssis[i].index, 1);
                            if (that.selectDataAssis[i].relation_order_no != "" && that.selectDataAssis[i].relation_order_no != null) {
                                let datatmp = {
                                    relation_order_no: that.selectDataAssis[i].relation_order_no,
                                    line_no: that.selectDataAssis[i].line_no,
                                }
                                parm.LineList.push(datatmp);
                            }
                        }
                        if (parm.LineList.length > 0) {
                            that.$http.urlpost('/Pur/GRN/PurGRNAssistDelLine', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.order_No != '') {
                                        that.getDetail(that.order_No);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            audit() {
                let that = this;
                let parm = {
                    order_no: that.dataDetail.InHead.order_no,
                    po_code: that.dataDetail.InHead.po_code,
                    LangType: that.$processdata.getLang(),
              };
                that.btn.Audit = false
                that.$http.urlpost('/Pur/GRN/PurReceiveInAudit', parm, function (res) {
                    that.btn.Audit = true
                    if (res.Success == 1) {
                        if(!that.$limits.fnIsEmpty(res.PopupTxt)){
                            that.loading = false;
                            that.isShowDialog = true
                            // that.value = res.Success
                            that.titleinfo = that.$processdata.explainCallbackMsg(res.Msg)
                            that.content = res.PopupTxt
                        }else{
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                        that.getDetail(res.UniqueNum);
                    }
                });
            },
            keepAccount() {
                let that = this;
                let parm = {
                    Code: that.dataDetail.InHead.order_no
                };
                that.btn.Balance = false
                that.$http.urlpost('/Pur/GRN/GetPurReceiveInKeepAccount', parm, function (res) {
                    that.btn.Balance = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.order_No);
                    }
                });
            },
            UpdateInvoiceQty() {
                let that = this;
                let parm = {
                    order_no: that.dataDetail.InHead.order_no,
                    modify_time: that.dataDetail.InHead.modify_time,
                };
                that.$http.urlpost('/Pur/GRN/UpdateInvoiceQty', parm, function (res) {
                    that.btn.RBalance = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.order_No);
                    }
                });
            },
            recoveryAccount() {
                let that = this;
                let parm = {
                    Code: that.dataDetail.InHead.order_no
                };
                that.btn.RBalance = false
                that.$http.urlpost('/Pur/GRN/GetPurReceiveInRecoveryAccount', parm, function (res) {
                    that.btn.RBalance = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.order_No);
                    }
                });
            },
            // 执行
            execute() {
                let that = this;
                let parm = {
                    order_no: that.dataDetail.InHead.order_no,
                    po_code: that.dataDetail.InHead.po_code,
                    LangType: that.$processdata.getLang(),
                };
                that.$refs.SetBtn.SetOneBtnEnable('execute', false);
                that.$http.urlpost('/Pur/GRN/PurReceiveInAudit', parm, function (res) {
                    if (res.Success == 1) {                         
                        if(!that.$limits.fnIsEmpty(res.PopupTxt)){
                            that.loading = false;
                            that.isShowDialog = true
                            that.titleinfo = that.$processdata.explainCallbackMsg(res.Msg)
                            that.content = res.PopupTxt
                        }else{
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                        that.getDetail(that.order_No);
                    }
                    that.$refs.SetBtn.SetOneBtnEnable('execute', true);
                });
            },
            // 导入可入库材料
            importPart() {
                let that = this
                let parm = {
                    po_code: that.dataDetail.InHead.po_code,
                    taxcode: that.dataDetail.InHead.taxcode,
                    tax_rate: that.dataDetail.InHead.tax_rate
                }
                that.$http.urlpost('/Pur/GRN/GetPurReceiveInImportPart', parm, function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent != null){
                            that.dataDetail.HasAssistList = res.DataContent.HasAssistList
                            that.dataDetail.NotAssistList = res.DataContent.NotAssistList
                        }
                    }
                });
            },
            //单据删除
            del() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.InHead.order_no
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del', false);
                        that.$http.urlpost('/Pur/GRN/DelPurReceive', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del', true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd();
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 获取采购和库存计量实入数
            getPurAInvQty(row){
                let that = this
                if (that.timeId) {
                    clearTimeout(that.timeId)
                }
                that.timeId = setTimeout(() => {
                    let index = row.$rowIndex
                    let parm = {
                        part_code: that.dataDetail.HasAssistList[index].part_code,
                        part_version: that.dataDetail.HasAssistList[index].part_version,
                        pur_measure_actually_qty: that.dataDetail.HasAssistList[index].pur_measure_actually_qty,
                        exchange_rate: that.dataDetail.HasAssistList[index].exchange_rate,
                        inv_measure_actually_qty: that.dataDetail.HasAssistList[index].inv_measure_actually_qty,
                        unit_price: that.dataDetail.HasAssistList[index].unit_price,
                        assist_measure: '',
                        assist_measure_actually_qty: that.dataDetail.HasAssistList[index].assist_measure_actually_qty
                    }
                    that.$http.urlpost('/Pur/GRN/GetPurReceiveInAssistQty', parm, function (res) {
                        if (res.Success == 1) {
                            let data = res.DataContent
                            that.dataDetail.HasAssistList[index].pur_measure_actually_qty = data.pur_measure_actually_qty
                            that.dataDetail.HasAssistList[index].inv_measure_actually_qty = data.inv_measure_actually_qty
                            that.dataDetail.HasAssistList[index].line_total_amount = data.line_total_amount
                            that.dataDetail.HasAssistList[index].line_tax_amount = ((1+that.dataDetail.InHead.tax_rate/100)*data.line_total_amount).toFixed(that.amountDigit)

                        }
                        clearTimeout(that.timeId)
                    });
                }, 500);
            },
            getPurOInvQty(row,type){
                let that = this
                let index = row.$rowIndex
                if(type == 1){
                    that.dataDetail.HasAssistList[index].inv_measure_actually_qty = that.dataDetail.HasAssistList[index].pur_measure_actually_qty * that.dataDetail.HasAssistList[index].exchange_rate
                    that.dataDetail.HasAssistList[index].pur_measure_actually_qty = that.dataDetail.HasAssistList[index].inv_measure_actually_qty / that.dataDetail.HasAssistList[index].exchange_rate
                    that.dataDetail.HasAssistList[index].line_total_amount = (that.dataDetail.HasAssistList[index].inv_measure_actually_qty * that.dataDetail.HasAssistList[index].unit_price).toFixed(that.amountDigit)
                    that.dataDetail.HasAssistList[index].line_tax_amount = ((1+that.dataDetail.InHead.tax_rate/100)*that.dataDetail.HasAssistList[index].line_total_amount).toFixed(that.amountDigit)
                } else if (type == 2){
                    that.dataDetail.HasAssistList[index].pur_measure_actually_qty = that.dataDetail.HasAssistList[index].inv_measure_actually_qty / that.dataDetail.HasAssistList[index].exchange_rate
                    that.dataDetail.HasAssistList[index].inv_measure_actually_qty = that.dataDetail.HasAssistList[index].pur_measure_actually_qty * that.dataDetail.HasAssistList[index].exchange_rate
                    that.dataDetail.HasAssistList[index].line_total_amount = (that.dataDetail.HasAssistList[index].inv_measure_actually_qty * that.dataDetail.HasAssistList[index].unit_price).toFixed(that.amountDigit)
                    that.dataDetail.HasAssistList[index].line_tax_amount = ((1+that.dataDetail.InHead.tax_rate/100)*that.dataDetail.HasAssistList[index].line_total_amount).toFixed(that.amountDigit)
                }
            },
            getNotPurInvQty(row,type){
                let that = this
                let index = row.$rowIndex
                if(type == 1){
                    that.dataDetail.NotAssistList[index].inv_measure_actually_qty = that.dataDetail.NotAssistList[index].pur_measure_actually_qty * that.dataDetail.NotAssistList[index].exchange_rate
                    that.dataDetail.NotAssistList[index].pur_measure_actually_qty = that.dataDetail.NotAssistList[index].inv_measure_actually_qty / that.dataDetail.NotAssistList[index].exchange_rate
                    that.dataDetail.NotAssistList[index].line_total_amount = (that.dataDetail.NotAssistList[index].inv_measure_actually_qty * that.dataDetail.NotAssistList[index].unit_price).toFixed(that.amountDigit)
                    that.dataDetail.NotAssistList[index].line_tax_amount = ((1+that.dataDetail.InHead.tax_rate/100)*that.dataDetail.NotAssistList[index].line_total_amount).toFixed(that.amountDigit)
                } else if (type == 2){
                    that.dataDetail.NotAssistList[index].pur_measure_actually_qty = that.dataDetail.NotAssistList[index].inv_measure_actually_qty / that.dataDetail.NotAssistList[index].exchange_rate
                    that.dataDetail.NotAssistList[index].inv_measure_actually_qty = that.dataDetail.NotAssistList[index].pur_measure_actually_qty * that.dataDetail.NotAssistList[index].exchange_rate
                    that.dataDetail.NotAssistList[index].line_total_amount = (that.dataDetail.NotAssistList[index].inv_measure_actually_qty * that.dataDetail.NotAssistList[index].unit_price).toFixed(that.amountDigit)
                    that.dataDetail.NotAssistList[index].line_tax_amount = ((1+that.dataDetail.InHead.tax_rate/100)*that.dataDetail.NotAssistList[index].line_total_amount).toFixed(that.amountDigit)
                }
            },
            sortChange(column){
                let that = this
                let name = column.property
                if(column.order == "asc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return -1;
                        } else if (val1 > val2) {
                            return 1;
                        } else {
                            return that.dataDetail.NotAssistList.indexOf(obj1) - that.dataDetail.NotAssistList.indexOf(obj2);
                        }
                    }
                    that.dataDetail.NotAssistList.sort(compare);
                    that.dataDetail.NotAssistList = [...that.dataDetail.NotAssistList]
                } else if(column.order == "desc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return 1;
                        } else if (val1 > val2) {
                            return -1;
                        } else {
                            return that.dataDetail.NotAssistList.indexOf(obj2) - that.dataDetail.NotAssistList.indexOf(obj1);
                        }
                    }
                    that.dataDetail.NotAssistList.sort(compare);
                    that.dataDetail.NotAssistList = [...that.dataDetail.NotAssistList]
                }
                that.sortRule.order = column.order
                that.sortRule.property = column.property
            },
            // 排序
            sortChangeAssis(column){
                let that = this
                let name = column.property
                if(column.order == "asc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return -1;
                        } else if (val1 > val2) {
                            return 1;
                        } else {
                            return that.dataDetail.HasAssistList.indexOf(obj1) - that.dataDetail.HasAssistList.indexOf(obj2);
                        }
                    }
                    that.dataDetail.HasAssistList.sort(compare);
                    that.dataDetail.HasAssistList = [...that.dataDetail.HasAssistList]
                } else if(column.order == "desc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return 1;
                        } else if (val1 > val2) {
                            return -1;
                        } else {
                            return that.dataDetail.HasAssistList.indexOf(obj2) - that.dataDetail.HasAssistList.indexOf(obj1);
                        }
                    }
                    that.dataDetail.HasAssistList.sort(compare);
                    that.dataDetail.HasAssistList = [...that.dataDetail.HasAssistList]
                }
                that.sortRule.order = column.order
                that.sortRule.property = column.property
            },
            selectInfo(tab){
                let that = this
                that.RightSelectIndex=tab.name
                this.$nextTick(function(){
                    this.$processdata.initFormRight(this.RightSelectIndex)
                });
            },
            collsoPrint(){
                let that = this
                let parm = {

                }
                that.$http.urlpost('/Print/GetPrinter', parm, function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent){
                            that.printerArr = res.DataContent
                            that.printerid = window.localStorage.getItem('printerid') == undefined?'':parseInt(window.localStorage.getItem('printerid'))
                            for(let i=0;i<that.printerArr.length;i++){
                                if(that.printerid == that.printerArr[i].id){
                                    that.selectPrinterDetail = that.printerArr[i]
                                    break
                                }
                            }
                        }
                        that.showCollsoPrint = true
                    }
                });
            },
            changePrinter(val){
                let that = this
                console.log(val)
                for(let i=0;i<that.printerArr.length;i++){
                    if(val == that.printerArr[i].id){
                        that.selectPrinterDetail = that.printerArr[i]
                    }
                }
            },
            getPrinterArr(){
                let that = this
                that.$http.urlpost('/Print/GetPrinter', {}, function (res) {
                    if (res.Success == 1) {
                        that.printerArr = res.DataContent
                    }
                });
            },
            confirmCollsoPrint(){
                let  that = this
                that.printerid = window.localStorage.setItem('printerid', that.selectPrinterDetail.id)
                let code = []
                for(let i=0;i<that.dataDetail.NotAssistList.length;i++){
                    code = [...code,{
                        part_code:that.dataDetail.NotAssistList[i].part_code,
                        part_version:that.dataDetail.NotAssistList[i].part_version,
                        part_name:that.dataDetail.NotAssistList[i].part_name,
                        cargoposition_code:that.dataDetail.NotAssistList[i].cargoposition_code,
                        batch_no:that.dataDetail.NotAssistList[i].batch_no,
                        pur_measure_actually_qty:that.dataDetail.NotAssistList[i].pur_measure_actually_qty,
                        expiry_date:that.dataDetail.NotAssistList[i].expiry_date,
                        audit_date:that.dataDetail.InHead.audit_date,
                    }]
                }
                for(let i=0;i<that.dataDetail.HasAssistList.length;i++){
                    code = [...code,{
                        part_code:that.dataDetail.HasAssistList[i].part_code,
                        part_version:that.dataDetail.HasAssistList[i].part_version,
                        part_name:that.dataDetail.HasAssistList[i].part_name,
                        cargoposition_code:that.dataDetail.HasAssistList[i].cargoposition_code,
                        batch_no:that.dataDetail.HasAssistList[i].batch_no,
                        pur_measure_actually_qty:that.dataDetail.HasAssistList[i].pur_measure_actually_qty,
                        expiry_date:that.dataDetail.HasAssistList[i].expiry_date,
                        audit_date:that.dataDetail.InHead.audit_date,
                    }]
                }
                let RequestData = { 'user': that.user,'data':code,'printer':that.selectPrinterDetail,'copies':that.copies};
                $.ajax({
                    url: that.selectPrinterDetail.ip,
                    type: 'post',
                    contentType: 'application/json',
                    data: JSON.stringify(RequestData),
                    success: function (res) {
                        that.showCollsoPrint = false
                    },
                    error: function (xhr, errorType, error) {

                    }
                });
            },
            editPrinter(){
                let that = this
                that.showPrinter = true
            },
            addPrinter(){
                let that = this
                that.showEditPrinter = true
                that.addoreditprint = 1
                that.printerDetail = {
                    id: '',
                    ip: '',
                    model: '',
                    name: ''
                };
            },
            editPrinter_(row) {
                let that = this
                that.showEditPrinter = true;
                that.addoreditprint = 2
                that.printerDetail = {
                    id: row.row.id,
                    ip: row.row.ip,
                    model: row.row.model,
                    name: row.row.name
                };
            },
            delPrinter_(row){
                let that = this
                let parm = {
                    id: row.row.id,
                    ip: row.row.ip,
                    model: row.row.model,
                    name: row.row.name
                }
                that.$http.urlpost('/Print/DeletePrinter', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.$http.urlpost('/Print/GetPrinter', {}, function (res) {
                            if (res.Success == 1) {
                                that.printerArr = res.DataContent
                            }
                        });
                    }
                });
            },
            savePrinter(){
                let that = this
                let parm = that.printerDetail
                if(that.addoreditprint == 1){
                    that.$http.urlpost('/Print/InsertPrinter', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.showEditPrinter = false
                            that.getPrinterArr()
                        }
                    });
                } else if(that.addoreditprint == 2){
                    that.$http.urlpost('/Print/UpdatePrinter', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.showEditPrinter = false
                            that.getPrinterArr()
                        }
                    });
                }
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 215,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.NotAssistList.length;i++){
                    delete datacopy.NotAssistList[i]['index']
                    delete datacopy.NotAssistList[i]['_XID'];
                }
                for(let i = 0;i<datacopy.HasAssistList.length;i++){
                    delete datacopy.HasAssistList[i]['index']
                    delete datacopy.HasAssistList[i]['_XID'];
                }
                let flag =  that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
